<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { paymentService } from "../../../../services/reportservice/paymentservice.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Receive Payment Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Input,
    Select, 
  },
  data() {
    return {
      title: "Receive Payment Report",
      data: [],
      date: '',
      projects: {},
      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',

      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 0,
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
     
    loadingData: function() {
      
      paymentService.getDetailPayment()
        .then(response => {
          this.data = response.data.payment;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projects = response.data.project;
          this.projectName = response.data.project_name;

        });
    },
    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId+'&start_date='+this.dataStartDate+'&end_date='+this.dataEndDate
      paymentService.getDetailPayment(data)
        .then(response => {
          this.data = response.data.payment;
          this.date = response.data.date;
          this.dataStartDate = response.data.date.start_date;
          this.dataEndDate = response.data.date.end_date;
          this.projects = response.data.project;
          this.projectName = response.data.project_name;
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '0.00';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    }
  },
  computed: {
    totalPiad() {
      return this.data.reduce(function (sum, item) {
        return sum + item.paid
      }, 0)
    },
    totalIntegerPay() {
      return this.data.reduce(function (sum, item) {
        return sum + item.integer_pay
      }, 0)
    },
    totalInterest() {
      return this.data.reduce(function (sum, item) {
        return sum + item.interest
      }, 0)
    },
    totalPrinciplePay() {
      return this.data.reduce(function (sum, item) {
        return sum + item.principal_pay
      }, 0)
    },
    totalPenalty() {
      return this.data.reduce(function (sum, item) {
        return sum + item.penalty
      }, 0)
    },
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('report.payment.receive')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="dataStartDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="dataEndDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="21%"><p>&nbsp;</p></td>
                <td width="20%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class=""><u>{{$t('report.text')+$t('report.payment.receive')}}</u></p>
                    <p class=""><u>ប្រចាំខែ: {{this.dateFormat(date.start_date)}} - {{this.dateFormat(date.end_date)}}</u></p>
                    <p class=""><u>គម្រោង: {{this.projectName}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
           <table class="content-general h8 project-sumary-table" width="100%">
              
                <tr class="thead">
                  <th rowspan="2">N<u>o</u></th>
                  <!-- <th rowspan="2">{{$t('project.text')}}</th> -->
                  <th rowspan="2">{{$t('setting.configuration.contract-template.type')}}</th>
                  <th rowspan="2">{{$t('property.text')}}</th>
                  <th rowspan="2">{{$t('payment.code')}}</th>
                  <th rowspan="2">{{$t('customer.type')}}</th>
                  <th rowspan="2">{{$t('report.payment.customer-name')}}</th>
                  <th rowspan="2">{{$t('customer.phone-no')}}</th>
                  <th rowspan="2">{{$t('report.payment.pay-date')}}</th>
                  <th rowspan="2">{{$t('report.payment.paid-date')}}</th>
                  <th colspan="3">{{$t('report.payment.pay-amount')}}</th>
                  <th colspan="3">{{$t('report.payment.paid-amount')}}</th>
                  <th rowspan="2" >{{$t('report.payment.due-amount')}}</th>
                </tr>
                <tr class="thead">
                  <th>{{$t('report.sale-unit.total')}}</th>
                  <th>{{$t('report.sale-unit.interest')}}</th>
                  <th>{{$t('report.payment.principle-payment')}}</th>
                  <th>{{$t('report.sale-unit.total')}}</th>
                  <th>{{$t('report.sale-unit.interest')}}</th>
                  <th>{{$t('report.payment.principle-payment')}}</th>
                </tr>
               
              <tbody>
                <tr v-for="(list, index) in data" :key="index" >

                  <td>{{index + 1}}</td>
                  <td>{{list.loan_type='installment' ? $t('report.payment.installment') : $t('report.payment.pay_off')}}</td>
                  <td>{{list.property_name}}</td>
                  <td>{{list.code}}</td>
                  <td>{{list.customer_type}}</td>
                  <td>{{list.customer_name}}</td>
                  <td>{{list.customer_phone}}</td>
                  <td>{{dateFormat(list.pay_date)}}</td>
                  <td>{{dateFormat(list.paid_date)}}</td>
                  <td>{{formatCurrency(list.integer_pay)}}</td>
                  <td>{{formatCurrency(list.interest)}}</td>
                  <td>{{formatCurrency(list.principal_pay)}}</td>

                  <td>{{formatCurrency(list.integer_pay)}}</td>
                  <td>{{formatCurrency(list.interest)}}</td>
                  <td>{{formatCurrency(list.paid)}}</td>

                  <td>{{formatCurrency(list.integer_pay-list.paid)}}</td>
                </tr>
              </tbody>
                <tr class="tfoot" v-if="data">
                  <td colspan="9" class="text-end pe-2">{{$t('report.total')}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(totalIntegerPay)}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(totalInterest)}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(totalPrinciplePay)}}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(totalIntegerPay-totalPiad)}}</td>
                  <td></td>
                </tr>
            </table>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>